import { useCallback, useState } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { EquipmentPickupForm } from './EquipmentPickupForm';
import { ModalForm } from './forms/ModalForm';
import { toasty } from './forms/FormElements';
import { submitPickupTimesheet } from './submitPickupTimesheet';

export const EquipmentPickupModal = ({
    isOpen,
    toggle,
    project,
    contractId,
    onSuccess,
}) => {
    const [pickupDetails, setPickupDetails] = useState(null);

    const handleSubmit = useCallback(async () => {
        try {
            const tn = await submitPickupTimesheet(pickupDetails);
            toggle();
            setPickupDetails(null);
            onSuccess(tn);
        } catch (error) {
            if (!error?.message?.includes('pickup quantity greater than zero')) {
                toasty.error(error?.message || 'An error occurred while creating the timesheet.');
            }
        }
    }, [pickupDetails, toggle, onSuccess]);

    if (!isOpen) return null;

    return (
        <ModalForm
            isOpen={isOpen}
            toggle={toggle}
            onSubmit={handleSubmit}
            title="Add Equipment Pickup Timesheet"
            size="lg"
            SaveButtonProps={{
                label: 'Add',
                savingLabel: 'Adding',
                icon: faPlus,
                disabled: !pickupDetails,
            }}
        >
            <EquipmentPickupForm
                project={project}
                contractId={contractId}
                pickupDetails={pickupDetails}
                setPickupDetails={setPickupDetails}
            />
        </ModalForm>
    );
};
